// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"25e596fd","652":"c21c9740"}[chunkId] + ".chunk.js";
};